import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _21_LEGACY:Partial<EcosystemServiceModel> ={
  id:'legacy',
  pos:21,
  image: "/images/ecoservices/legacy.jpg",
  code: ["3.2.2.2", "3.3.2.1", "6.2.2.1"],
  unit:'legacy',
  assetType: 'highValue',
  serviceType: 'cultural',
  valuationMethods:[
    {
      id: 'contingent',
      name:"Contingent Valuation (WTP)",
      unit: "person",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'contingent_public',
      name:"Contingent Valuation (public budgets)",
      unit: "person",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },

  ]

}
